<!-- <app-nav-bar></app-nav-bar> -->
<div class="wrapper animated fadeIn">
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/hero.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px"><span>{{"demo.Bienvenidos" | translate}}</span><br> Willis Towers Watson </h1>
        </div>
    </div>
    <!-- end .row -->
    <div class="container-fluid">
        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Menu Principal</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Inicio</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <app-info-user [home]="searchMenu" [configuracion]="false" (changeCompany)="isChangeCompany($event)"></app-info-user>
        <!--/ end row -->
        <div class="row">
            <div *ngIf="sarlaftMenu" class="col-md-6 col-lg-4">
                <div class="card m-b-30 puntero" [routerLink]='["/sarlaft-form"]'>
                    <div class="card-body">
                        <h5 class="card-title">Sarlaft</h5>
                        <h6 class="card-subtitle text-muted">Ingrese aquí para actualizar el Formulario de Conocimiento de Cliente SARLAFT</h6>
                    </div>
                    <img class="img-fluid" src="./assets/global/images/small/sarlaft.jpg" alt="Sarlaft">
                </div>
            </div>
            <!-- end col -->
            <div *ngIf="siniestroMenu" class="col-md-6 col-lg-4">
                <div class="card m-b-30 puntero" [routerLink]='["/clains"]'>
                    <img class="card-img-top img-fluid" src="./assets/global/images/small/siniestros.jpg" alt="Siniestros">
                    <div class="card-body">
                        <h5 class="card-title">Siniestros</h5>
                        <h6 class="card-subtitle text-muted">Ingrese aquí para radicar su siniestro</h6>
                    </div>
                </div>
            </div>
            <!-- end col -->
            <div *ngIf="pacsMenu" class="col-md-6 col-lg-4">
                <div class="card m-b-30 puntero" [routerLink]='["/wepac"]'>
                    <div class="card-body">
                        <h5 class="card-title">WePAC</h5>
                        <h6 class="card-subtitle text-muted">Programa de Atención a Contratistas.
                        </h6>
                    </div>
                    <img class="img-fluid" src="./assets/global/images/small/PACs.jpg" alt="PACs">
                </div>
            </div>
            <!-- end col -->
            <div *ngIf="weCumplimientoMenu" class="col-md-6 col-lg-4">
                <div class="card m-b-30 puntero" [routerLink]='["/weCumplimiento"]'>
                    <div class="card-body">
                        <h5 class="card-title">WeCumplimiento</h5>
                        <h6 class="card-subtitle text-muted">PROGRAMA ATENCION A CLIENTES.
                        </h6>
                    </div>
                    <img class="img-fluid" src="./assets/global/images/small/PACs.jpg" alt="weCumplimiento">
                </div>
            </div>
            <!-- end col -->
            <div *ngIf="administracionComercialMenu" class="col-md-6 col-lg-4">
                <div class="card m-b-30 puntero" [routerLink]='["/user-comercial"]'>
                    <div class="card-body">
                        <h5 class="card-title">Administración Comercial</h5>
                        <h6 class="card-subtitle text-muted">Ingrese aquí para buscar, editar o crear un usuario.
                        </h6>
                    </div>
                    <img class="img-fluid" src="./assets/global/images/small/siniestros.jpg" alt="ADministración Comercial">
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
        <div class="clearfix"></div>
    </div>
    <!-- end container -->
</div>
<!-- <app-footer></app-footer> -->